module.exports = __webpack_public_path__ + "static/media/truck.bdcf6e5f.svg";